import { createSuitMixin as n } from "../mixins/suit.js";
import { _objectSpread as t } from "./polyfills.js";
import { version as e } from "./vue-compat/index-vue2.js";
import { warn as a } from "./warn.js";
import { INSTANTSEARCH_FUTURE_DEFAULTS as i } from "instantsearch.js/es/lib/InstantSearch.js";
import { version as s } from "../../package.json.js";

var r = function r(_r) {
  var c;
  return t(((c = {
    mixins: [n({
      name: "InstantSearch"
    })],
    provide: function provide() {
      return {
        $_ais_instantSearchInstance: this.instantSearchInstance
      };
    },
    watch: {
      searchClient: function searchClient(n) {
        a(!1), this.instantSearchInstance.helper.setClient(n).search();
      },
      indexName: function indexName(n) {
        this.instantSearchInstance.helper.setIndex(n || "").search();
      },
      stalledSearchDelay: function stalledSearchDelay(n) {
        this.instantSearchInstance._stalledSearchDelay = n;
      },
      routing: function routing() {
        throw new Error("routing configuration can not be changed dynamically at this point.\n\nPlease open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props");
      },
      onStateChange: function onStateChange() {
        throw new Error("onStateChange configuration can not be changed dynamically at this point.\n\nPlease open a new issue: https://github.com/algolia/instantsearch/discussions/new?category=ideas&labels=triage%2cLibrary%3A+Vue+InstantSearch&title=Feature%20request%3A%20dynamic%20props");
      },
      searchFunction: function searchFunction(n) {
        this.instantSearchInstance._searchFunction = n;
      },
      middlewares: {
        immediate: !0,
        handler: function handler(n, t) {
          var e = this;
          (t || []).filter(function (t) {
            return -1 === (n || []).indexOf(t);
          }).forEach(function (n) {
            e.instantSearchInstance.unuse(n);
          }), (n || []).filter(function (n) {
            return -1 === (t || []).indexOf(n);
          }).forEach(function (n) {
            e.instantSearchInstance.use(n);
          });
        }
      },
      future: function future(n) {
        this.instantSearchInstance.future = Object.assign(i, n);
      }
    },
    created: function created() {
      var n = this.instantSearchInstance.client;
      "function" == typeof n.addAlgoliaAgent && (n.addAlgoliaAgent("Vue (" + e + ")"), n.addAlgoliaAgent("Vue InstantSearch (" + s + ")"));
    },
    mounted: function mounted() {
      var n = this;
      this.$nextTick(function () {
        n.instantSearchInstance.started || n.instantSearchInstance.start();
      });
    }
  }).beforeDestroy = function () {
    this.instantSearchInstance.started && this.instantSearchInstance.dispose(), this.instantSearchInstance.__initialSearchResults = void 0;
  }, c), _r);
};

export { r as createInstantSearchComponent };